"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var CalculateProject_1 = require("./Calculator/CalculateProject");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var GetBillingSummary_1 = require("./Calculator/GetBillingSummary");
var ProjectTotal = (function () {
    function ProjectTotal(quoteBlocksList, accountQuoteSettings, variableService, discountService, billingScheduleOrchestrator, quoteCalculatorSettings) {
        var _this = this;
        this.quoteBlocksList = quoteBlocksList;
        this.accountQuoteSettings = accountQuoteSettings;
        this.variableService = variableService;
        this.discountService = discountService;
        this.billingScheduleOrchestrator = billingScheduleOrchestrator;
        this.quoteCalculatorSettings = quoteCalculatorSettings;
        this.hasVisibleQuoteTotal = function () {
            var e_1, _a;
            if (_this.quoteBlocksList && _this.quoteBlocksList.getAdapters) {
                try {
                    for (var _b = __values(_this.quoteBlocksList.getAdapters()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var adapter = _c.value;
                        if (adapter.showQuoteTotals()) {
                            return true;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return false;
            }
            else {
                throw new Error("quoteBlocksList.getAdapters does not exist. hasVisibleQuoteTotal() is only meant to be used in Public");
            }
        };
        this.calculatePayTodaySingleCurrency = function () {
            var totals = (0, lodash_1.mapValues)(_this.calculateProject(), function (f) { return f.postTax; });
            return totals[Object.keys(totals)[0]];
        };
        this.calculateProject = function () {
            var _a;
            var taxes = (_a = _this.accountQuoteSettings.taxes) !== null && _a !== void 0 ? _a : [];
            var blocks = _this.quoteBlocksList.get();
            return (0, CalculateProject_1.calculateProject)(blocks, taxes, _this.variableService, _this.discountService, _this.billingScheduleOrchestrator, _this.quoteCalculatorSettings());
        };
        this.getBillingSummary = function (currency) {
            var _a;
            return (0, GetBillingSummary_1.getBillingSummary)({
                blocks: _this.quoteBlocksList.get(),
                currency: currency,
                taxes: (_a = _this.accountQuoteSettings.taxes) !== null && _a !== void 0 ? _a : [],
                variableService: _this.variableService,
                discountService: _this.discountService,
            });
        };
        this.billingFrequencies = function () {
            var e_2, _a, e_3, _b, e_4, _c;
            var _d;
            var quoteBlocks = _this.quoteBlocksList
                .get()
                .filter(function (block) { return block.type === BlockTypes_1.BlockType.Quote; });
            var frequencies = new Set();
            try {
                for (var quoteBlocks_1 = __values(quoteBlocks), quoteBlocks_1_1 = quoteBlocks_1.next(); !quoteBlocks_1_1.done; quoteBlocks_1_1 = quoteBlocks_1.next()) {
                    var quote = quoteBlocks_1_1.value;
                    try {
                        for (var _e = (e_3 = void 0, __values(quote.sections)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var section = _f.value;
                            try {
                                for (var _g = (e_4 = void 0, __values(section.items)), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    var item = _h.value;
                                    if ("billingSchedule" in item && ((_d = item.billingSchedule) === null || _d === void 0 ? void 0 : _d.type) === Types_1.BillingScheduleType.Recurring) {
                                        frequencies.add(item.billingSchedule.frequency);
                                    }
                                }
                            }
                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                                }
                                finally { if (e_4) throw e_4.error; }
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (quoteBlocks_1_1 && !quoteBlocks_1_1.done && (_a = quoteBlocks_1.return)) _a.call(quoteBlocks_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return __spreadArray([], __read(frequencies), false);
        };
    }
    return ProjectTotal;
}());
exports.default = ProjectTotal;
